import { ActionIcon, Badge, Button, Checkbox, Modal, MultiSelect, SegmentedControl, Tooltip } from '@mantine/core';
import { useDebouncedValue, useFocusReturn } from '@mantine/hooks';
import 'keen-slider/keen-slider.min.css';
import { AllCountries, AllOperators, OperatorKey, OperatorList, Payment, res_get_me, WEEK, getLastMonday, isPastOrNextMonday, isMonday, NormalizeToCompanyName, NormalizeToCompanyID, SaleType, SaleTypeCounted, PaymentResponse, SaleTypeContributesToStripeTotal, SaleTypeContributesToWiseTotal, HR, ORIGIN_MONDAY, startOfDay, autoDST, getNearestMonday, getTZOffset } from 'ratpack-server/src/types';
import 'ratpack-ui/src/app/AppImports';
import { Anchor } from 'ratpack-ui/src/components/Anchor/Anchor';
import { Button as RPButton } from 'ratpack-ui/src/components/Button/Button';
import { DatePicker } from 'ratpack-ui/src/components/DatePicker/DatePicker';
import { Select } from 'ratpack-ui/src/components/Select/Select';
import { Text } from 'ratpack-ui/src/components/Text/Text';
import { TextInput } from 'ratpack-ui/src/components/TextInput/TextInput';
import { AdminListQuotesPage } from 'ratpack-ui/src/pages/AdminListQuotesPage';
import { AdminPageLayout } from 'ratpack-ui/src/pages/AdminPageLayout';
import 'ratpack-ui/src/styles/Font.css';
import * as React from 'react';
import { useState } from 'react';
import { atom, atomFamily, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { GET, POST } from '../api';
import { BarGraph } from '../BarGraph';
import { FXCurrency } from '../currency';
import { MustLogIn, userAtom } from '../session';
import { DDMMYYYY, useTime } from '../time';
import { dollar, stateful } from '../util';
import { adminDefaults, hotPink } from './components';
import { RPNumberInput } from './finalise';
import { getAgentType } from './TeamPage';
import { AiFillWarning, AiOutlineReload, AiOutlineUndo, AiOutlineWarning } from 'react-icons/ai';

const ZD_URL = `https://theratpacktravelteam.zendesk.com/agent/tickets`
const STRIPE_URL = `https://dashboard.stripe.com/invoices`

const ScrollButton = ({ direction }) => {
    return (
      <button
        onClick={() => window.scrollTo(0, direction === 'top' ? 0 : document.body.scrollHeight)}
        style={{
          position: 'fixed',
        //   top: direction === 'top' ? 20 : undefined,
          bottom: direction === 'bottom' ? 20 : 50,
          right: 20,
        //   display: direction === 'top'
        //     ? `${window.scrollY > 10 ? '' : 'none'}`
        //     : `${window.innerHeight + window.scrollY - document.body.offsetHeight < 50 ? '' : 'none'}`,
          padding: 0,
          cursor: 'pointer',
          borderRadius: '4px',
          backgroundColor: hotPink,
          color: 'white',
          opacity: '.8',
          zIndex: 99999,
        }}
      >
        {direction=='top' ? '↑' : '↓'}
      </button>
    );
  };
  
export const ScrollTop = () => <ScrollButton direction="top" />;
export const ScrollBottom = () => <ScrollButton direction="bottom" />;

const SaleTypeShort:Partial<Record<SaleType,string>> = {
    NewSaleDeposit: 'NS-D',
    NewSaleFullSplit: 'NS-FS',
    NewSaleFullFull: 'NS-FF',
    PayOffFull: 'PO-F',
    "MANUAL-NS": 'MANUAL-NS',
    "MANUAL-PO": 'MANUAL-PO',
    "MANUAL-REF": 'MANUAL-Ref',
    'WISE-NS': 'WISE-NS',
    'WISE-PO': 'WISE-PO',
    'WISE-REF': 'WISE-REF',
    // VIRTUAL: 'V',
}
const SaleTypes = Object.keys(SaleTypeShort)

const SaleTypeLong:Record<SaleType,string> = {
    NewSaleDeposit: 'New Sale Deposit: Customer has paid for the deposit, and will pay the rest on arrival',
    NewSaleFullSplit: 'New Sale Full Split: Customer has paid the first split of a full payment order',
    NewSaleFullFull: 'New Sale Full Paid in Full: Customer has paid off in full for a full payment order',
    PayOffFull: 'Pay Off Full: Customer has paid off a full payment',
    "MANUAL-NS": 'Manual Pay Off: Customer has manually paid a new sale',
    "MANUAL-PO": 'Manual Pay Off: Customer has manually paid off a full payment',
    "MANUAL-REF": 'Refund: Customer was refunded a payment',
    "WISE-NS": 'WISE New Sale: Customer has paid via Wise',
    "WISE-PO": 'WISE Pay Off: Customer has paid off a full payment via Wise',
    "WISE-REF": 'WISE Refund: Customer was refunded a payment via Wise',
    VIRTUAL: 'Virtual: Used for development and layout',  
}
const SaleTypeColor:Record<SaleType,string> = {
    NewSaleDeposit: '#A8D8A0',
    NewSaleFullSplit: '#A8D8A0',
    NewSaleFullFull: '#A8D8A0',
    PayOffFull: '#F8A07A',
    "MANUAL-NS": '#A8D8A0',//green as the NS-D and NS-F
    "MANUAL-PO": '#F8A07A',//same orange as PO-F
    "MANUAL-REF": 'red',//red the same as AU
    "WISE-NS": '#A8D8A0',//green as the NS-D and NS-F
    "WISE-PO": '#F8A07A',//same orange as PO-F
    "WISE-REF": 'red',//red the same as AU
    //     NewSaleDeposit: '#A8D8A0', // '#D5EDC0',
    //     NewSaleFullSplit: '#A8D8A0', // '#D5EDC0',
    //     PayOffFull: '#F8A07A', // '#FEC9AD',
    //     Refund: 'red',
    VIRTUAL: 'black',
    //     MANUAL: 'pink',
    //     'MANUAL-WISE': 'blue',
}


export const SaleTypeGroup:Record<SaleType,number> = {
    NewSaleDeposit: 1,
    NewSaleFullSplit: 1,
    NewSaleFullFull: 1,
    PayOffFull: 1,
    "MANUAL-NS":2,
    "MANUAL-PO":3,
    "MANUAL-REF":4,
    "WISE-NS":5,
    "WISE-PO":6,
    "WISE-REF":7,
    VIRTUAL: null,
}

const sortingIndexer = (ab: Payment) => {
    const c = new Date(ab.created_at)
    const d = new Date(ab.paid_at)
    const [Y,M,DD] = YMDInSydney(d)
    const index = [
        Y,
        M,
        DD,
        SaleTypeGroup[ab.SaleType], // ((ab.SaleType.startsWith('MANUAL')) ? 2 : 1),
        d.getTime(),
        c.getTime(),
    ].join('_')
    return index
}

const SortWithinDays = (payments: Array<Payment>) => { // WARNING, do not try to sort the frozen array from recoil, but also do not try to unpack and sort except at the point of use
    console.log({sort:payments})
    if (!Array.isArray(payments)) return payments
    return payments.sort((a: Payment, b: Payment) => {
        return sortingIndexer(a).localeCompare(sortingIndexer(b))
        // return a.paid_at.getDate()-b.paid_at.getDate()
    })
}

type paymentQuery = {
    selectedWeek: Date,
    latest?: Date,
    lastUpdatedPayment?: number, // Date.getTime()
}
const DAY = 24 * HR
const UTC = (d:Date|number) => {
    const D = new Date(d)
    return D.getTime()+(D.getTimezoneOffset()*60e3)
}
const getPayments = async ({ selectedWeek, latest, lastUpdatedPayment }: paymentQuery): Promise<PaymentResponse> => {
    const MOE = DAY // margin of error while dates are being fixed, used to force date rounding up to the current week when we are a few hours short due to errors
    console.log({ selectedWeek, latest, lastUpdatedPayment, now: new Date() })
    if (latest && lastUpdatedPayment) return await GET(`/api/payments/${selectedWeek.getTime()+MOE}/${new Date(latest).getTime()}/${lastUpdatedPayment}`)
    return await GET(latest ? `/api/payments/${selectedWeek.getTime()+MOE}/${new Date(latest).getTime()}` : `/api/payments/${selectedWeek.getTime()+MOE}`)
}

const paymentsAtom = atomFamily<PaymentResponse, paymentQuery>({
    key: 'payments',
    default: getPayments
})

export const unionBy = <T = Payment>(arr1: T[], arr2: T[], key: keyof T): T[] => {
    const seen = new Set(arr2.map(item => item[key]))
    return [...arr1.filter(item => !seen.has(item[key])), ...arr2]
}

const NaNor = (nan: number | Date, nor: any = 0) => (!nan || isNaN(typeof nan == 'number' ? nan : nan.getDate?.())) ? nor : nan
const usePayments = (selectedWeek: Date, onFirstLoad=()=>{}) => {
    console.log(`Using payments with selected week: ${selectedWeek}`)
    const rounded = getLastMonday(selectedWeek.getTime())
    const [latest, setLatest] = useRecoilState(paymentsAtom({ selectedWeek: rounded }))
    const [isPolling, setIsPolling] = useState(false)
    const [stopped, setStopped] = useState(false)
    const [error, setError] = useState(null)
    const [lastUpdated, setLastUpdated] = useState(Date.now())

    const [refreshSignal, setRefreshSignal] = useState(0)

    const sow = getLastMonday().getTime()
    const isCurrentWeek = rounded.getTime() >= sow

    // TODO: move refresh function out to avoid reinstantiation

    React.useEffect(() => {
        let timer: NodeJS.Timeout

        const interval = isCurrentWeek ? 10e3 : 5 * 60e3

        const refresh = async () => {
            if (isPolling) return console.error(`Aborted refresh because polling is already set`)
            setIsPolling(true)
            const resetter = setTimeout(()=>setIsPolling(false), 2e3)
            try {
                const { rates, payments, paymentStats, target, youManage, allAgentsAndAdmins, allTeams } = await getPayments({
                    selectedWeek: rounded,
                    latest: latest.payments?.at(-1)?.paid_at,
                    lastUpdatedPayment: NaNor((latest.payments ?? []).map(p => new Date(p.updatedAt)?.getTime()).sort((a, b) => a - b).at(-1), null), // get updates from the 2nd newest update onwards (because the newest might be an update we just made)
                })
                setLatest(prev => ({ rates, payments: unionBy(prev.payments, payments, 'StripePaymentID'), paymentStats, target, youManage, allAgentsAndAdmins, allTeams }))
                if (rates) setLastUpdated(Date.now())
                setError(null)
            } catch (e) {
                console.log(`SETTING REFRESH ERROR:`, e)
                setError(e)
            }
            setIsPolling(false)
            clearTimeout(resetter)
            if (!stopped) timer = setTimeout(refresh, interval)
            if(!window['firstLoad']) {
                window['firstLoad']=true
                console.log('first load')
                onFirstLoad()
            }
        }

        if (!isPolling) {
            refresh()
        } else {
            if (!stopped) timer = setTimeout(refresh, interval)
        }

        return () => { [setStopped(true), clearTimeout(timer)] }
    }, [selectedWeek, isCurrentWeek, refreshSignal])

    const refreshPayments = () => setRefreshSignal(()=>Math.random())
    return { latest, loading: isPolling, lastUpdated, error, refreshPayments }
}

// export const AdminColumns = 

const HEADERS = {
    admin: {
        before: [null],
        groups: { // Admin
            Pax: [
                'PaxName',
                // 'PaxLocation',
                // 'ZDID',
            ],
            Booking: [
                // 'Country',
                // 'Company', // TODO: merge vertically
                'Model',
                'Duration',
            ],
            Accounts: [
                'Sale Type',
                'Stripe', // AUD/NZD with hover
                'Card Fee (2.9%)',
                // 'Stripe Fee',
                // 'Total (AUD)',
            ],
            Commission: [
                'Camper', // AUD/NZD
            ],
            'Team': [
                'Team Member',
                // 'Ad Referral',
                'Confirmation',
                'Comm AUD',
                'Notes',
            ],
            // '': [
            // ]
        },
        // after: [null],
        after: [],
    },
    manager: {
        before: [null],
        groups: { // Admin
            Pax: [
                'PaxName',
                // 'PaxLocation',
                // 'ZDID',
            ],
            Booking: [
                // 'Country',
                // 'Company', // TODO: merge vertically
                'Model',
                'Duration',
            ],
            Accounts: [
                'Sale Type',
                'Stripe', // AUD/NZD with hover
                // 'Total (AUD)',
            ],
            Commission: [
                'Camper', // AUD/NZD
            ],
            'Team': [
                'Team Member',
                // 'Ad Referral',
                'Confirmation',
                'Comm AUD',
                'Notes',
            ],
            // '': [
            // ]
        },
        // after: [null],
        after: [],
    },
    agent: {
        before: [null],
        groups: { // Admin
            Pax: [
                'PaxName',
                // 'PaxLocation',
                // 'ZDID',
            ],
            Booking: [
                // 'Country',
                // 'Company', // TODO: merge vertically
                'Model',
                'Duration',
            ],
            Accounts: [
                'Sale Type',
                'Stripe', // AUD/NZD with hover
                // 'Total (AUD)',
            ],
            Commission: [
                'Camper', // AUD/NZD
            ],
            '': [
                // 'Ad Referral',
                'Confirmation',
                'Comm AUD',
                'Notes',
            ]
        },
        // after: [null],
        after: [],
    },
} as const
const DayHeaderHeight = '125px'

const toRelativeTime = (ms: number): string => {
    ms = Math.max(0, ms)
    const sec = ms / 1000
    if (sec < 60) return `${Math.floor(sec)} sec ago`;
    const min = sec / 60
    if (min < 60) return `${Math.floor(min)} min ago`;
    const hrs = min / 60
    if (hrs < 24) return `${Math.floor(hrs)} hr ago`;
    const days = hrs / 24
    return `${Math.floor(days)} day${days > 1 ? 's' : ''} ago`;
}

const dayCode = (item):string =>{
    const [Y,M,D,Group,time] = sortingIndexer(item).split('_')
    return [Y,M,D].join('_')
} 
const dayOf = (item:Payment): Date => {
    const date = new Date(item?.paid_at ?? 0)
    // const t = date.getTime()
    // const offset = (t-ORIGIN_MONDAY)%DAY
    // return new Date(t-offset)
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    return date
}
const dayOfAEST = (item): Date => {
    const date = OffsetLocalToAEST(new Date(item?.paid_at ?? 0))
    const t = date.getTime()
    const offset = (t-ORIGIN_MONDAY)%DAY
    return new Date(t-offset)
}
const dayHeader = (date = new Date(), text='') => {
    if(!text) text = `${DDMMYYYY(date)}${DDMMYYYY(date) == DDMMYYYY(new Date()) ? ' (Today)' : ''}`
    return (<tr
        // ref={el => headersRef.current[date.getTime()] = el}
        className="section-header"
        colSpan="100%"
        style={{
            position: 'sticky',
            top: DayHeaderHeight,
            background: '#f8f9fa',
            zIndex: 1,
        }}
    >
        <td
            style={{
                textAlign: 'center',
                backgroundColor: '#36454F',
                color: 'white',
            }}
            colSpan="100%"
        >
            {text}
        </td>
    </tr>)
}
{/* const weekFooterDataBy = (visiblePayments: Payment[], rates: PaymentResponse['rates'] | null, axis: keyof Payment | Function): Record<string, WeekFooter> => {
    const groups: Record<string, Payment[]> = visiblePayments.reduce((t, p) => {
        const k = (typeof axis == 'function' ? axis(p) : p[axis]).toString()
        t[k] = t[k] || []
        t[k].push(p)
        return t
    }, {})
    return Object.fromEntries(Object.entries(groups).map(([k, v]) => [k, weekFooterData(v, rates)]))
} */}

const weekFooterData = (visiblePayments: Payment[], rates: PaymentResponse['rates'] | null): WeekFooter & any => {
    const stripePayments = visiblePayments.filter(p => SaleTypeContributesToStripeTotal[p.SaleType]) // includes manual
    const wisePayments = visiblePayments.filter(p => SaleTypeContributesToWiseTotal[p.SaleType]) // TODO: handle negative values here to ensure refunds with positive amount are subtracted
    // const manualPayments = visiblePayments.filter(p => (['MANUAL-NS','MANUAL-PO','MANUAL-REF'] as SaleType[]).includes(p.SaleType))

    const countablePayments = visiblePayments.filter(p => SaleTypeCounted[p.SaleType])
    
    const getCurrencies = (payments) => {
        const AUD = payments.reduce((t, v) => t + (v.StripeAUD??0), 0)
        const NZD = payments.reduce((t, v) => t + (v.StripeNZD??0), 0)
        const NZDasAUD = NZD / rates?.rates?.NZD
        return [AUD,NZD,NZDasAUD]
    }
    const [stripeAUD,stripeNZD,stripeNZDasAUD] = getCurrencies(stripePayments)
    const [wiseAUD,wiseNZD,wiseNZDasAUD] = getCurrencies(wisePayments)
    // const stripe = stripeAUD + stripeNZD
    const fees = visiblePayments.reduce((t, v) => t + v.StripeFee / (v.StripeNZD ? rates?.rates?.NZD : 1), 0) // Fees are normalized to AUD
    const card = visiblePayments.reduce((t, v) => t + v.CardFee / (v.StripeNZD ? rates?.rates?.NZD : 1), 0) // Fees are normalized to AUD

    const days = countablePayments.reduce((t, v) => t + v.Duration, 0) / (countablePayments.length||1) // TODO: handle omitted days by first filtering
    const gross = visiblePayments.reduce((t, v) => t + v.TotalAUD, 0)
    const commAUD = visiblePayments.reduce((t, v) => t + (v.CommAUD??0) * (v.CamperAUD ? 1 : 0), 0)
    // const commNZDasAUD = visiblePayments.reduce((t, v) => t + (v.CommAUD??0) * (v.CamperNZD ? 1 : 0), 0)
    // const commNZD = commNZDasAUD * rates?.rates?.NZD
    const n=(n:number|string)=>isNaN(parseFloat(n as any))?0:parseFloat(n as any);
    const commNZD = visiblePayments.reduce((t, v) => t + n(v.CamperNZD), 0)
    const commNZDasAUD = commNZD / rates?.rates?.NZD
    const comm = commAUD + commNZDasAUD

    const targetPeriod = 0
    const targetDaily = 0
    const remaining = targetPeriod - comm

    return {
        "Days": days,
        "Units": countablePayments.length,
        "Stripe AUD": stripeAUD,
        "Stripe NZD": stripeNZD,
        "TotalStripe": stripeAUD+stripeNZDasAUD,
        "TotalWise": wiseAUD+wiseNZDasAUD,
        // "Total": stripe,
        "Stripe Fees": fees,
        "Card Fees": card,
        "Gross": gross,
        "Comm AUD": commAUD,
        "Comm NZD": commNZD,
        "Comm": comm,
        "Target": targetPeriod,
        "Day Target": targetDaily,
        "Remaining": remaining,
    }
}
const weekFooter = (visiblePayments: Payment[], rates: PaymentResponse['rates'] | null, user: res_get_me, target:number, selectedWeek:Date) => {
    const setViewingGraph = useSetRecoilState(viewingGraphAtom)
    const data = weekFooterData(visiblePayments, rates)

    const admin = user.admin
    const manager = user.manages?.length

    const base = {
        // textAlign: 'center' as const,
        backgroundColor: '#36454F',
        color: 'white',
        padding: '10px 0px',
        border: 0,
        textAlign: 'left' as const,
        borderLeft: '10px #00000000 solid',
    }
    const clickable = {
        ...base,
        textDecoration: 'underline',
        cursor: 'pointer',
    }
    const rightSeparator = (basedOn=base, lower=false) => ({
        ...basedOn,
        [lower ? 'borderBottom' : 'borderTop']: '8px #00000000 solid',
        boxShadow: 'inset -2px 0px 0 0px white',
    })
    const pad = <td style={base}></td>
    type FooterCol = {head:React.ReactElement,body:React.ReactElement}
    const pads = {head:pad,body:pad} as FooterCol

    // TODO: compute data[*] from loaded info, and show graphs using stats from server

    const managerCols:FooterCol[] = ( /*manager||*/ admin) ? [
        {
            head:<td style={base}>Stripe Fees</td>,
            body: <td style={base}>
                {dollar(data['Stripe Fees'])}
                <br/>
                {dollar(data['Card Fees'])} (2.9%)
                <br/>
                {dollar(data['Card Fees']-data['Stripe Fees'])}
            </td>,
        },
        {
            head:<td style={rightSeparator(clickable)}>
                <Tooltip label={[
                    `${dollar(data['Stripe AUD'])} AUD`,
                    <br/>,
                    `${dollar(data['Stripe NZD'])} NZD`,
                ]}><div>Stripe Total</div></Tooltip>
            </td>,
            body: <td style={rightSeparator(base,true)}>
                {dollar(data['TotalStripe'])} AUD
            </td>,
        },
        {
            head:<td style={rightSeparator(base)}>Wise Total</td>,
            body: <td style={rightSeparator(base,true)}>
                {dollar(data['TotalWise'])} AUD
            </td>,
        },
        {
            head:<td style={rightSeparator(base)}>Total Rev</td>,
            body: <td style={rightSeparator(base,true)}>
                {dollar(data['TotalStripe']+data['TotalWise'])} AUD
            </td>,
        },
    ] : []
    const soyc = new Date(selectedWeek.getFullYear()+'-01-01')
    const TZOFFSET = getTZOffset(soyc)
    const soy = soyc.getTime()+TZOFFSET
    const adminCols:FooterCol[] = (admin) ? [
        {
            head:<td style={rightSeparator(base)}>Export</td>,
            body: <td style={rightSeparator(base,true)}>
                <Anchor color="white" style={{color:'white'}} href={`/api/data/csv/${selectedWeek.getTime()}/week`} target="_blank" rel="noopener noreferrer">This Week</Anchor>
                <br/>
                <Anchor color="white" style={{color:'white'}} href={`/api/data/csv/${soy}/${soy+(52*WEEK)}`} target="_blank" rel="noopener noreferrer">This Year</Anchor>
            </td>,
        },
    ] : []
    const cols:FooterCol[] = [
        pads,
        {
            head:<td style={rightSeparator(clickable)} onClick={e => setViewingGraph('Units')}>Booking Stats</td>,
            body:<td style={rightSeparator(base,true)}>
                Units: {data['Units']}
                <br/>
                Av Days: {(data['Days']??0).toFixed(1)}
            </td>
        },
        ...managerCols,
        {
            head: <td style={clickable} onClick={e => setViewingGraph('Comm')}>Total Comms</td>,
            body: <td style={base}>
                {dollar(data['Comm AUD'])} AUD
                <br/>
                {dollar(data['Comm NZD'])} NZD
            </td>
        },
        {
            head: <td style={rightSeparator(clickable)} onClick={e=>setViewingGraph('Averages')}>Total Comms AUD</td>,
            body: <td style={rightSeparator(base,true)}>
                {dollar(data['Comm'])} AUD
            </td>
        },
        {
            head: <td style={clickable} onClick={e=>setViewingGraph('Target')}>Target</td>,
            body: <td style={base}>
                Daily: {dollar(target/5)}
                <br/>
                Weekly: {dollar(target)}
                <br/>
                Remaining: {dollar(target - data['Comm'])}
            </td>
        },
        ...adminCols,
        pads,
    ]

    return <td colSpan="100%"><table cellSpacing="0" cellPadding="0" style={{ padding: 0, width: '100%' }}><tr
        colSpan="100%"
        style={{
            backgroundColor: '#36454F',
            padding: 0,
        }}
    >
        {cols.map((c)=>c.head)}
    </tr><tr
        colSpan="100%"
        style={{
            backgroundColor: '#36454F',
        }}
    >
        {cols.map((c)=>c.body)}
    </tr></table></td>
}
const endOfDay = (d:Date) => {
    const D = new Date(d)
    D.setHours(23,59,59,999)
    return D
}
const dayFooter = ({
    user,
    dayPayments,//: Payment[],
    // visiblePayments,//: Payment[],
    day,//:Date,
    setEditingPayment,//:Function
    rates,
    agent_type,
}) => {
    const NZDRate = rates?.rates?.['NZD']

    const endDay = endOfDay(day)
    // const dayPayments = visiblePayments.filter(p => startOfDay(day)<=p.paid_at && p.paid_at <= endDay) // endOfDay(p.paid_at)==endDay)
    
    const stripeAUD = dayPayments.reduce((t:number,p:Payment)=>t+(p.StripeAUD??0),0)
    const stripeNZD = dayPayments.reduce((t:number,p:Payment)=>t+(p.StripeNZD??0),0)
    const stripe = stripeAUD + (stripeNZD / (NZDRate ?? 1))

    const comm = dayPayments.reduce((t:number,p:Payment)=>t+(p.CommAUD??0),0)


    type AgentType = keyof typeof HEADERS
    type HeaderGroups = typeof HEADERS[keyof typeof HEADERS]['groups']
    type HeaderColumn = HeaderGroups[keyof HeaderGroups][number]


    const { before, groups, after } = HEADERS[agent_type as AgentType]
    const columns = Object.values(groups).flatMap(v=>v) as HeaderColumn[]
    const FooterCols = {
        "Stripe":<Tooltip
            label={[
                `${dollar(stripeAUD)} AUD`,
                <br/>,
                `${dollar(stripeNZD)} NZD`,
            ]}
        ><div><Text>{dollar(stripe)}</Text></div></Tooltip>,
        "Comm AUD": <Text>{dollar(comm)}</Text>,
        // "Card Fee (2.9%)": 0,
    } as Partial<Record<HeaderColumn,any>>

    const FooterColsWidth = { 
        "Stripe": 2,
        // "Card Fee (2.9%)": 0,
        "Comm AUD": 2,
        // "Notes": 0,
    } as Partial<Record<HeaderColumn,number>>

    const topLine = Object.assign([ // ADMIN: TODO join with the header setup
        ...before.map(()=>''),
        ...columns.map((c)=>FooterCols[c]??''), //.filter(v => v!==0),
        ...after.map(()=>''),
    ],[
        <RPButton onClick={(e:any) => { setEditingPayment(newPayment(user?.username, endDay)) }}>+</RPButton>,
    ])

    return <>
        <AdminListQuotesPage.TableRow
            key={'Manual' + day.getTime()}
            {...({
                // colSpans: columns.map((c)=>FooterColsWidth[c]??1), // [1,1,1,1,0,0,99],
                topLine,
            })}
        />
    </>
}
const LastUpdatedText = ({ loadedPayments, lastUpdated, loadingPayments, updatePayments, error }) => {
    const now = useTime(1000)
    return <>
        <Tooltip label={`Update now`}>
            <ActionIcon
                style={{ padding: '8px 0 0 5px', color:loadingPayments?'gray':'black', display: 'inline' }}
                onClick={() => {
                    spinOnce('reloadIcon')
                    updatePayments()
                }}
                disabled={loadingPayments}
            >                                    
                <AiOutlineReload size={16} id="reloadIcon" />
            </ActionIcon>
        </Tooltip>
        <Tooltip label={error?.toString() ?? `Automatically updating`}>
            <p style={{ display: 'inline', color: error ? '#FF6868' : 'lightgrey', paddingLeft: '5px' }}>{(!loadedPayments) ? 'Loading...' : `Updated ${toRelativeTime(now.getTime() - lastUpdated)}`}</p>
        </Tooltip>
    </>
}
const COMMISSION_SHADE = '#b7dfcd'

const Divider = ({
    children = '',
    style = {},
}) => (<div style={{
    display: 'flex',
    alignItems: 'center',
    ...style,
}}>
    <span>{children}</span>
    <div style={{
        flex: 1,
        marginLeft: '0.5rem',
        borderBottom: '1px solid #ddd'
    }} />
</div>
)

type CountryCode = 'AU' | 'NZ'
type CountryName = 'Australia' | 'New Zealand'
const NormalizeToCountryCode = (Country: string): CountryCode => {
    return ({ Australia: 'AU', 'New Zealand': 'NZ' }[Country] ?? Country) as CountryCode
}
const NormalizeToCountryName = (Country: string): CountryName => {
    return ({ AU: 'Australia', NZ: 'New Zealand' }[Country] ?? Country) as CountryName
}

function setKeyOfEvent<T = Payment>(setter: React.Dispatch<(p: T) => T>) {
    return (k: keyof T, pre: Function = (v: any) => v) => <E = React.ChangeEventHandler>(e: E & { target: { value: T[typeof k] } }) =>
        setter((p: T) => ({ ...p, [k]: pre(e?.target?.value ?? (e as any)) }))
}

const combi = (...f: any[]) => (e: any) => f.map(f => f(e))
const companiesInCountry = (country: string | 'AU' | 'NZ') => {
    const C = NormalizeToCountryCode(country)?.toUpperCase()
    if (C == 'AU') return Object.entries(OperatorList).filter(([k]) => k.startsWith('au.')).map(([value, label]) => ({ value: value.split('.').at(-1), label }))
    if (C == 'NZ') return Object.entries(OperatorList).filter(([k]) => k.startsWith('nz.')).map(([value, label]) => ({ value: value.split('.').at(-1), label }))
    return [{ value: 'err', label: `No companies for country ${C}`, disabled: true }]
}

const agentSlug = (s:string) => s.split('@')[0].replace(/[^a-z0-9]/gi, '_').toLowerCase();
const newPayment = (TeamMember: string, paid_at: Date): Payment => {
    // TODO: new payments on current day can have current time (not end of day) used as paid_ad
    // TODO: sort manual payments to the end by type, not only end-of-day
    // if(getDayString(paid_at) == getDayString(new Date())) paid_at = new Date()
    const initial = {
        TeamMember,
        SaleType: 'MANUAL-NS',
        paid_at: endOfDay(paid_at),
        StripePaymentID: `MANUAL.${agentSlug(TeamMember)}.${(Date.now() + Math.random()).toFixed(2)}`,
        InitialsConfirmation: '',
        NOTES: '',
        TotalAUD: 0,
        CommAUD: 0,
        StripeAUD: 0,
        StripeNZD: 0,
        CamperAUD: 0,
        CamperNZD: 0,
        StripeFee: 0,
        CardFee: 0,
    } as Partial<Payment>
    return initial as Payment
}

type Company = string
const modelsForCompany = (company: Company) => {
    Object.entries(OperatorList).map(([value, label]) => ({ value, label }))
    return [{ value: 'model', label: 'Model' }]
}
const setter = (v: any) => v

function canAccess(user: res_get_me, isMyManualPayment: boolean, agentCanAccess = false, manualOwnerCanAccess = true, managerCanAccess = true, adminCanAccess = true): Boolean {
    // TODO ensure that user manages THIS team?
    return (adminCanAccess && user.admin) || (managerCanAccess && Boolean(user.manages?.length)) || (manualOwnerCanAccess && isMyManualPayment) || agentCanAccess
}

const editingPaymentAtom = atom<Payment | null>({
    key: 'editingPaymentAtom', // unique ID (with respect to other atoms/selectors)
    default: null as any, // default value (aka initial value)
})
type graphOption = 'Units'|'Comm'|'UnitsAdmin'|'CommAdmin'|'Averages'|'Target'|null
const viewingGraphAtom = atom<graphOption>({
    key: 'viewingGraphAtom', // unique ID (with respect to other atoms/selectors)
    default: null as any, // default value (aka initial value)
})

const EditModal = ({
    setEditingLoading,
    refreshPayments,
    editingLoading,
    NZDRate,
    allAgents,
    allAgentsAndAdmins,
}) => {

    const user = useRecoilValue(userAtom)
    const [editingPayment, setEditingPayment] = useRecoilState(editingPaymentAtom)
    const isManual = ['MANUAL','MANUAL-WISE'].includes((editingPayment as Payment)?.SaleType)
    const isMyManualPaymentOld = (editingPayment as Payment)?.TeamMember == user.username && isManual
    const [IDTypeOrStripePayment, IDAgent, IDUnix, IDRandom] = (editingPayment as Payment)?.StripePaymentID?.split('.') ?? []
    const isMyManualPayment = (isManual && IDAgent == agentSlug(user.username)) || isMyManualPaymentOld
    const myManagedAgents = useRecoilValue(managedAgentsAtom)
    // const allAgents = useRecoilValue()
    // const myManagedAgents = user.admin ? allAgents : allAgents.filter(a => user.manages.some(t => a.team.includes(t)))

    const editE = React.useCallback(setKeyOfEvent(setEditingPayment), [setEditingPayment]);

    const [errorMessage, setErrorMessage] = useState('')

    const canAccessDefaultRead = React.useMemo(() => {
        console.log(`computed some memo`)
        return canAccess(user, isMyManualPayment, true, true, true, true)
    }, [user, isMyManualPayment]);
    const canAccessDefaultWrite = React.useMemo(() => canAccess(user, isMyManualPayment, false, true, false, true), [user, isMyManualPayment]);
    const canAccessNotes = React.useMemo(() => canAccess(user, isMyManualPayment, true, true, true, true), [user, isMyManualPayment]);

    const gridColumn = '1 / -1' // used to set a form field in the grid layout as full-width

    const saveEditingPayment = () => {
        setEditingLoading(true)
        // TODO: add WARNING to note for payments which are flagged as losing money
        // const payment = editingPayment
        // let NOTE = editingPayment.NOTES
        // if(editingPayment.CamperAUD)
        // if(editingPayment)
        POST(`/api/payment/edit/${editingPayment.StripePaymentID}`, editingPayment).then(res => {
            if (res?.error) {
                setErrorMessage(res.error)
                setEditingLoading(false)
                return
            }
            setErrorMessage('')
            refreshPayments()
            setEditingLoading(false)
            setEditingPayment(null)
        }).catch(e => {
            setErrorMessage(e?.message ?? `Error: ${e}`)
        })
    }

    // const currency = editingPayment?.CamperNZD?'NZD':'AUD'
    const currency = NormalizeToCountryCode(editingPayment?.Country) == 'NZ' ? 'NZD' : 'AUD'
    // console.log('Rendering modal',currency)


    const stripe_url = `${STRIPE_URL}/${editingPayment?.StripeInvoiceID}`
    if(editingPayment?.NOTES == 'TEST A FRONTEND ERROR PLEASE') throw `Test error`

    const Stripe = ({
        NewSaleDeposit: 'Stripe',
        PayOffFull: 'Stripe',
        NewSaleFullSplit: 'Stripe',
        NewSaleFullFull: 'Stripe',
        VIRTUAL: 'DEV',
        'MANUAL-NS': 'Manual',
        'MANUAL-PO': 'Manual',
        'MANUAL-REF': 'Manual',
        'WISE-NS': 'Wise',
        'WISE-PO': 'Wise',
        'WISE-REF': 'Wise',
    }as Record<SaleType,string>)[editingPayment?.SaleType]

    const setTotalAUD = combi(
        editE('TotalAUD', (v: number) => v * 100),
        editE('CardFee', (v: number) => v * 0.029 * 100),
        editE('StripeFee', (v: number) => v * 0.03 * 100),
        // (v:number)=>{
        //     if(!isManual) return
        //     if(editingPayment.Country=='AU') return
        //     editE('StripeNZD', (v: number) => v * NZDRate)(v as any)
        // },
    )
    const setCommAUD = (n:number) => editE('CommAUD', (v: number) => v * 100)(n as any)
    // const isWarning = editingPayment?.NOTES?.startsWith('WARNING:')
    const isPending = editingPayment?.NOTES?.startsWith('PENDING:')
    const togglePending = (isPending:boolean) => editE('NOTES')((isPending ? `PENDING: ${editingPayment?.NOTES}` : editingPayment?.NOTES.slice('PENDING:'.length).trimStart()) as any)


    const COUNTRIES = AllCountries.map(({ name, code }) => ({ value: code, label: name }))
    const COMPANIES = companiesInCountry(editingPayment?.Country)
    const DESTINATIONS = [{ value: 'AU', label: 'Australia' }, { value: 'NZ', label: 'New Zealand' }]
    const ASSIGNABLE = user.admin ? Object.keys(allAgentsAndAdmins??{}) : myManagedAgents
    console.log({COUNTRIES,COMPANIES,DESTINATIONS,myManagedAgents,ASSIGNABLE,allAgents,allAgentsAndAdmins})

    return <Modal
        size="75%"
        opened={Boolean(editingPayment)}
        onClose={() => saveEditingPayment()} // TODO prevent double click
        closeOnClickOutside={false}
        closeOnEscape={false}
        withCloseButton={false}
        styles={{
            body: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1rem',
            }
        }}
    >
        {canAccessDefaultRead && editingPayment?.StripeInvoiceID && <Anchor href={stripe_url} style={{ gridColumn, textDecoration: 'underline', cursor: 'pointer' }} onClick={e => openTab(stripe_url, e)}>Invoice ID: {editingPayment?.StripeInvoiceID}</Anchor>}
        {canAccessDefaultRead && <Text style={{ gridColumn }}>Payment ID: {editingPayment?.StripePaymentID}</Text>}
        {(user.admin && <Select searchable={false} label="Sale Type" placeholder="..." value={editingPayment?.SaleType} onChange={editE('SaleType')} data={SaleTypes}></Select>) || <Text>Sale Type: {toSaleTypeFlag(editingPayment?.SaleType)}</Text>}
        {<div>
            {[
                // editingPayment?.StripeInvoiceID ? StripePill(editingPayment?.StripeInvoiceID) : null,
                editingPayment?.ZDTicketID ? ZDIDPill(editingPayment?.ZDTicketID) : null,
            ].filter(Boolean)}
        </div>}
        {
            ((user.admin || (ASSIGNABLE.includes(editingPayment?.TeamMember))) && <Select searchable={false} label="Agent" placeholder="..." value={editingPayment?.TeamMember} onChange={editE('TeamMember')} data={ASSIGNABLE}></Select>) ||
            (canAccessDefaultRead && <Text>Team Member: <Anchor href="#">{editingPayment?.TeamMember?.split('@')[0]}</Anchor></Text>)
        }

        {canAccessDefaultWrite && isMyManualPayment && (<>
            <Divider style={{ gridColumn }}>Payment Provider</Divider>
            <SegmentedControl data={[{label:'Stripe', value: 'MANUAL'},{label: 'Wise', value: 'MANUAL-WISE'}]} value={editingPayment?.SaleType} onChange={editE('SaleType')}></SegmentedControl>
        </>)}

        <Divider style={{ gridColumn }}>Pax</Divider>
        {canAccessDefaultWrite && <TextInput label="Name" placeholder="Name" value={editingPayment?.PaxName} onChange={editE('PaxName')}></TextInput> || canAccessDefaultRead && <Text>Name: {editingPayment?.PaxName}</Text>}
        {canAccessDefaultWrite && <Select searchable={true} label="Pax Location" placeholder="..." value={editingPayment?.PaxLocation} onChange={editE('PaxLocation')} data={COUNTRIES}></Select> || canAccessDefaultRead && <Text>Pax Location: {editingPayment?.PaxLocation}</Text>}

        <Divider style={{ gridColumn }}>Trip</Divider>
        {canAccessDefaultWrite && <RPNumberInput label="Days" placeholder="0" precision={0} min={0} hideControls value={editingPayment?.Duration} onChange={editE('Duration')}></RPNumberInput> || canAccessDefaultRead && <Text>Duration: {editingPayment?.Duration}</Text>}
        {canAccessDefaultWrite && <Select searchable={false} label="Country" placeholder="..." value={NormalizeToCountryCode(editingPayment?.Country)} onChange={editE('Country')} data={DESTINATIONS}></Select> || canAccessDefaultRead && <Text>Country: {NormalizeToCountryName(editingPayment?.Country)}</Text>}
        {canAccessDefaultWrite && <Select searchable={false} label="Company" placeholder="..." value={NormalizeToCompanyID(editingPayment?.Company, editingPayment?.Country)} onChange={editE('Company')} data={COMPANIES}></Select> || canAccessDefaultRead && <Text>Company: {editingPayment?.Company}</Text>}
        {/* {canAccessDefaultWrite && <Select searchable={false} label="Model" placeholder="..."  value={editingPayment?.Model} onChange={editE('Model')} data={modelsForCompany(editingPayment?.Company)}></Select> || canAccessDefaultRead && <Text>Model: {editingPayment?.Model}</Text>} */}
        {canAccessDefaultWrite && <TextInput label="Model" placeholder="..." value={editingPayment?.Model} onChange={editE('Model')}></TextInput> || canAccessDefaultRead && <Text>Model: {editingPayment?.Model}</Text>}

        <Divider style={{ gridColumn }}>Value</Divider>
        {canAccessDefaultWrite && <RPNumberInput label="Total AUD" placeholder="0" disabled={isManual&&editingPayment?.Country=='NZ'} precision={2} hideControls value={editingPayment?.TotalAUD / 100} onChange={setTotalAUD}></RPNumberInput> || canAccessDefaultRead && <Text>Total AUD: ${(editingPayment?.TotalAUD / 100).toFixed(2)}</Text>}
        {canAccessDefaultWrite && <RPNumberInput label="Comm AUD" placeholder="0" disabled={isManual&&editingPayment?.Country=='NZ'} precision={2} hideControls value={editingPayment?.CommAUD / 100} onChange={setCommAUD}></RPNumberInput> || canAccessDefaultRead && <Text>Comm AUD: ${(editingPayment?.CommAUD / 100).toFixed(2)}</Text>}


        {canAccessDefaultWrite && <RPNumberInput label={`${Stripe}${currency}`} placeholder="0" precision={2} hideControls value={(editingPayment?.[`Stripe${currency}`] ?? 0) / 100} onChange={combi(
            editE(`Stripe${currency}`, (v: number) => v * 100),
            (v:number)=>{
                if(currency=='NZD' && isManual) setTotalAUD(v/NZDRate)
            },
        )}></RPNumberInput> || canAccessDefaultRead && <Text>{`${Stripe}${currency}: $${(editingPayment?.[`Stripe${currency}`] / 100).toFixed(2)}`}</Text>}
        {canAccessDefaultWrite && <RPNumberInput label={`Camper${currency}`} placeholder="0" precision={2} hideControls value={(editingPayment?.[`Camper${currency}`] ?? 0) / 100} onChange={combi(
            editE(`Camper${currency}`, (v: number) => v * 100),
            (v:number)=>{
                if(currency=='NZD' && isManual) setCommAUD(v/NZDRate)
            },
        )}></RPNumberInput> || canAccessDefaultRead && <Text>{`Camper${currency}: $${(editingPayment?.[`Camper${currency}`] / 100).toFixed(2)}`}</Text>}


        {canAccessDefaultRead && <Text>Card Fee (2.9%): ${((editingPayment?.CardFee??0) / 100).toFixed(2)}</Text>}
        {canAccessDefaultRead && <Text>{Stripe} Fee: ${((editingPayment?.StripeFee??0) / 100).toFixed(2)}</Text>}

        {/* <div style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
        }}>
            {canAccessDefaultRead && <Text>Stripe Fee: ${(editingPayment?.StripeFee / 100).toFixed(2)}</Text>}
            {false && (canAccessDefaultWrite && <Text
                style={{
                    textDecoration: 'underline',
                    cursor: 'pointer',
                }}
                onClick={e=>{
                    setEditingPayment(p => ({
                        ...p,
                        CamperAUD: p.CamperAUD ? 0 : p.CamperNZD / NZDRate,
                        CamperNZD: p.CamperNZD ? 0 : p.CamperAUD * NZDRate,
                        StripeAUD: p.StripeAUD ? 0 : p.StripeNZD / NZDRate,
                        StripeNZD: p.StripeNZD ? 0 : p.StripeAUD * NZDRate,
                    }))
                }}
            >{currency}</Text> || canAccessDefaultRead && <Text>{currency}</Text>)}
        </div> */}

        {user.admin && <Divider style={{ gridColumn }}>Ad Referral</Divider>}
        {user.admin && <pre style={{fontSize: '0.75em', gridColumn: 'span 2'}}>{editingPayment?.AdReferral?.replace(', GCLID:','\r\nGCLID:')}</pre>}
        <Divider style={{ gridColumn }}>Agent</Divider>
        {canAccessNotes && <TextInput label="Initials & Confirmation" placeholder="..." value={editingPayment?.InitialsConfirmation} onChange={editE('InitialsConfirmation')}></TextInput> || canAccessDefaultRead && <Text>Initials & Confirmation: {editingPayment?.InitialsConfirmation}</Text>}
        {canAccessNotes && <div style={{display:'flex', width:'100%'}}>
            <TextInput label="Notes" placeholder="..." value={editingPayment?.NOTES} onChange={editE('NOTES')}></TextInput>
            <ActionIcon
                style={{ color:lightRed, margin: '5px', alignSelf: 'flex-end' }}
                onClick={() => togglePending(!isPending)}
            >
                {isPending?<AiFillWarning size={16} />:<AiOutlineWarning size={16} />}
            </ActionIcon>
        </div> || canAccessDefaultRead && <Text>Notes: {editingPayment?.NOTES}</Text>}

        <Divider style={{ gridColumn }}>Actions</Divider>
        {errorMessage && <Text color='red' style={{ gridColumn }}>{normalizeSaveError(errorMessage)}</Text>}
        <RPButton
            onClick={() => saveEditingPayment()} // update or insert the editing payment
            disabled={editingLoading}
        >{editingLoading ? 'Loading...' : 'Save'}</RPButton>
        <RPButton
            onClick={() => setEditingPayment(null)}
            disabled={editingLoading}
        >{'Discard'}</RPButton>
    </Modal>
}

function normalizeSaveError(e:string):string {
    return e
        .replace('Failed to update: SqliteError: NOT NULL constraint failed: payment_record.duration', 'Please provide the number of days')
        .replace('Failed to update: SqliteError: NOT NULL constraint failed: payment_record.', 'Please provide: ')
        .replace('Failed to update: SqliteError: NOT NULL constraint failed: ', 'Please provide: ')
        .replace('Failed to update: SqliteError: ', 'Error: ')
        .replace('Failed to update: ', 'Error: ')
}

function accumulateByKey(o: Record<string, any>, key: string) {
    return Object.entries(o).reduce((t, [agent, data]) => {
        t[agent] = (t[agent] ?? 0) + (data[key] ?? 0)
        return t
    }, {})
}

function SimpleDST(date:Date){ // Takes a UTC Date, returns Sydney Date
    date = new Date(date)
    if(!date?.getTime) return null
    if(isNaN(date?.getTime())) return null
    const b=new Date(date.toLocaleString('en-US', { timeZone: 'Australia/Brisbane' })).getTime() // Server handles times in AEST
    const s=new Date(date.toLocaleString('en-US', { timeZone: 'Australia/Sydney' })).getTime() // Sydney can be AEST or AEDT depending on DST
    const offset = Math.round((s-b)/3600e3) // 0 in AEST 1 in AEDT
    return new Date(date.getTime() + (offset*HR))
}

function timeInSydney(date:string|Date):string {
    const time = new Date(date).toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
    const PM = time.split(', ')[1].split(/\s/)[1]
    return time.split(', ')[1].split(':').slice(0,2).join(':')+` ${PM}`
}
function timeInSydney24(date:string|Date):string {
    const time = new Date(date).toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
    const PM = time.split(', ')[1].split(/\s/)[1]
    const [H,M] = time.split(', ')[1].split(':').slice(0,2)
    const h = parseInt(H)
    return [((PM=='PM' && (h<12))? (h+12)%24 : H).toString().padStart(2,'0'), M].join(':')
}
function YMDInSydney(date:string|Date):[string,string,string] {
    const time = new Date(date).toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
    const [m,d,y] = time.split(', ')[0].split('/')
    return [y,m.padStart(2,'0'),d.padStart(2,'0')]
}

const getDayString = (at:string|Date) => {
    const [y,m,d] = YMDInSydney(at)
    return [d,m,y].join('/')
}
const getDayStringToday = (at:string|Date):string => {
    const dmy = getDayString(at)
    return dmy + (getDayString(new Date())==dmy ? ` (Today)` : ``)
}

const PaymentRows = ({
    paymentsInTable,
    rates,
    paymentsInFooter,
    user,
    target,
    selectedWeek,
}) => {
    const setEditingPayment = useSetRecoilState(editingPaymentAtom)
    const agent_type = getAgentType(user)
    const AESTDay = (date:Date|string) => OffsetLocalToAEST(new Date(date)).getDay()
    const DSTDay = (date:Date|string) => {
        const offset = OffsetLocalToDST(new Date(date))
        const out = offset.getDay()
        console.log({date, offset, out})
        return out 
    }
    let firstOfTheDayIndex = 0
    const today = YMDInSydney(new Date())
    const output = (paymentsInTable as Payment[]).flatMap((item, i, a) => {
        // console.log({ item, i, dp: dayOf(a[i - 1]), d: dayOf(item) })
        const day = new Date(item?.paid_at)
        const prev = a[i - 1]
        const next = a[i + 1]
        // console.log({prev,next,day})
        // console.log({code:dayCode(item)})
        const isLast = i >= (a.length-1)
        // const isFirstOfDay = (!i) || (DSTDay(prev?.paid_at) != DSTDay(item?.paid_at))
        // const isLastOfDay = isLast || (next && (DSTDay(next?.paid_at) != DSTDay(item?.paid_at)))
        // const isFirstOfDay = (!i) || (SimpleDST(prev?.paid_at)?.getDay() != SimpleDST(item?.paid_at)?.getDay())
        const headerText = getDayStringToday(item.paid_at)
        const isFirstOfDay = (!i) || headerText != getDayStringToday(prev.paid_at)
        // const isLastOfDay = isLast || (next && (SimpleDST(next?.paid_at)?.getDay() != SimpleDST(item?.paid_at)?.getDay()))
        const isLastOfDay = isLast || (next && (headerText != getDayStringToday(next.paid_at)))

        // console.log({isFirstOfDay, isLastOfDay, prev:prev?.paid_at,item:item?.paid_at,next:next?.paid_at })
        const daySoFar = a.slice(firstOfTheDayIndex, i+1)
        if(isLastOfDay) firstOfTheDayIndex = i+1
        return [
            // Insert a header if this is the first on this date
            (isFirstOfDay ? dayHeader(
                OffsetLocalToAEST(new Date(item?.paid_at)), // Overridden by headerText
                headerText,
            ) : []),
            // Insert the row item
            // item.SaleType == 'VIRTUAL' ? <AdminListQuotesPage.TableRow
            //     key={'Manual' + day.getTime()}
            //     {...({
            //         colSpans: [5, 5],
            //         topLine: [ // ADMIN: TODO join with the header setup
            //             <Button key="add">+</Button>,
            //         ],
            //     })} /> : 
                (<PaymentToRowItem key={item?.StripePaymentID} {...{
                    payment: item,
                    rates,
                    setEditingPayment,
                    agent_type,
                }} />),

            // Insert a button to add a payment on this day
            (isLastOfDay ? dayFooter({
                agent_type,
                day,
                rates,
                setEditingPayment,
                user,
                dayPayments:daySoFar,
            }) : []),
        ]
    }).concat(weekFooter(paymentsInFooter, rates, user, target, selectedWeek))
    return <>{...output}</>
}

export const managedAgentsAtom = atom<string[]>({
    key: 'managedAgents',
    default: [],
})
// export const allAgentsWithPaymentsAtom = atom<string[]>({
//     key: 'allAgentsWithPayments',
//     default: [],
// })
export const allAgentsAndAdminsAtom = atom<Record<string,string>>({
    key: 'allAgentsAndAdmins',
    default: {},
})
export const allTeamsAtom = atom<Record<string,string[]>>({
    key: 'allTeams2',
    default: {},
})

const offsetToAEST = -600*60e3
const offsetToLocal = new Date().getTimezoneOffset()*60e3
const OffsetUTCToAEST = (d:Date=getLastMonday()) => new Date(d.getTime() - offsetToAEST) // only for presentation
const OffsetLocalToAEST = (d:Date=getLastMonday()) => new Date(d.getTime() - offsetToAEST + offsetToLocal) // only for presentation
const OffsetLocalToDST = (d:Date=getLastMonday()) => autoDST(OffsetLocalToAEST(d)) // only for presentation
const OffsetAESTToLocal = (d:Date=getLastMonday()) => new Date(d.getTime() + offsetToAEST - offsetToLocal) // only for presentation
const patchForward = (d:Date, add:number = 12*HR) => new Date(d.getTime()+add)
export default () => {
    const [selectedWeek, useSelectedWeekUTC, validSelectedWeek, setSelectedWeek] = stateful<Date>(patchForward(getLastMonday()), { setter }) // When the remaining balance is due
    console.log({selectedWeek})
    const useSelectedWeek = {
        value: (selectedWeek),
        onChange: (event => {
            const value = setter(event)
            console.log('set selected week', {value, lto:OffsetAESTToLocal(value)})
            return setSelectedWeek(patchForward(getNearestMonday(OffsetAESTToLocal(value))))
        })
    }
    const resetSelectedWeek = () => {
        console.error('RESET SELECTED WEEK')
        setSelectedWeek(patchForward(getLastMonday()))
    }
    if (!validSelectedWeek) {
        console.error('INVALID SELECTED WEEK')
        resetSelectedWeek()
    }
    const weeksAgo = Math.round((getLastMonday().getTime() - selectedWeek?.getTime()) / WEEK)

    const { latest, loading: loadingPayments, lastUpdated, error, refreshPayments } = usePayments(selectedWeek, ()=>{
        window.scrollTo(0, document.body.scrollHeight);
    })
    const { rates, payments, paymentStats, target, youManage, allAgentsAndAdmins, allTeams } = latest??{}

    const allAgents = Object.keys(paymentStats?.['Units'] ?? {})
    const setManagedAgents = useSetRecoilState(managedAgentsAtom)
    const setAllAgentsAndAdmins = useSetRecoilState(allAgentsAndAdminsAtom)
    const setAllTeams = useSetRecoilState(allTeamsAtom)
    // const setAllAgentsWithPayments = useSetRecoilState(allAgentsWithPaymentsAtom)

    React.useEffect(()=>{
        setManagedAgents(youManage)
    }, [youManage])
    React.useEffect(()=>{
        setAllAgentsAndAdmins(allAgentsAndAdmins)
    }, [Object.keys(allAgentsAndAdmins)])
    React.useEffect(()=>{
        setAllTeams(allTeams)
    }, [Object.values(allTeams).flat()])
    // React.useEffect(()=>{
    //     setAllAgentsWithPayments(uniq(payments.map(p=>teamMember)))
    // }, [payments])

    const loadedPayments = !loadingPayments
    const visiblePayments = payments.map(p => {
        // if(timeInSydney(p.paid_at)=='12:59 AM' && (['WISE-NS', 'WISE-PO', 'WISE-REF', 'MANUAL-NS', 'MANUAL-PO', 'MANUAL-REF'] as Array<Payment['SaleType']>).includes(p.SaleType)) return {...p, paid_at:new Date(new Date(p.paid_at).getTime()-HR)}
        return p
    // }).filter(p => {
    //     p.paid_at
    })

    // const refreshPayments = useRecoilRefresher_UNSTABLE(paymentsAtom({ selectedWeek }))
    const [loading, setLoading] = useState(false)
    const [editingLoading, setEditingLoading] = useState(false)

    // const [viewingGraph, setViewingGraph] = useState<'Units'|'Comm'|'Averages'|'Target'|null>(null)

    const [sortedPayments, setSortedPayments] = useState<Payment[]>([])
    const [debouncedVisiblePayments] = useDebouncedValue(visiblePayments, 500)

    const user = useRecoilValue(userAtom)
    const agent_type = getAgentType(user)

    const agentFilter = useRecoilValue(AgentFilterAtom)

    React.useEffect(() => {
        console.log(`Filtering... ${visiblePayments.length}`)
        if (sortedPayments.length == 0 && visiblePayments.length == 0) {
            setSortedPayments([])
            return
        }
        setSortedPayments(SortWithinDays([...visiblePayments]))
    }, [
        debouncedVisiblePayments,
    ])

    if (loading) return <Text>Loading payment data...</Text>

    const bulkActionsSelect = null
    const applyButton = null
    const leftContent = ''
    const NZDRate = rates?.rates?.['NZD']

    const rightContent = <>
        <EditModal
            key="edit"
            {...{
                allAgents,
                editingLoading,
                setEditingLoading,
                refreshPayments,
                NZDRate,
                allAgentsAndAdmins,
            }}
        ></EditModal>
        <GraphModal paymentStats={paymentStats} admin={user.admin}/>
    </>
    const allAgentsInTeam = (team:string) => Object.entries(allTeams).filter(([agent,teams])=>teams.includes(team)).map(([agent])=>agent)
    const effectiveAgentFilter = Array.from(new Set(agentFilter.map(v=>v?.startsWith('#') ? allAgentsInTeam(v?.slice(1)) : v).flat()))
    return (<AdminPageLayout {...adminDefaults({ page: 'payments' })} page={<>
        <MustLogIn />
        <ScrollTop/>
        <ScrollBottom/>
        <ErrorBoundary fallback={<p>Something went wrong while rendering the page</p>}>
            <AdminListQuotesPage
                containerPadding={0}
                extras={{ // max width
                    pageMaxWidthContainer: {
                        style: {
                            maxWidth: '100vw',
                        }
                    },
                    innerContainer: {
                        style: {
                            padding: '0px',
                        }
                    },
                }}
                heading={<div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 20px' }}>
                    <h2>Payments</h2>{
                        <DatePicker
                            {...useSelectedWeek}
                            style={{
                                maxWidth: '280px',
                            }}
                            placeholder="Select"
                            label={[
                                (
                                    weeksAgo == 0 ? 'This week' :
                                        weeksAgo == -1 ? 'Next week' :
                                            weeksAgo == 1 ? 'Last week' :
                                                `${weeksAgo} weeks ago`
                                ),
                                <LastUpdatedText loadedPayments={loadedPayments} lastUpdated={lastUpdated} error={error} loadingPayments={loadingPayments} updatePayments={refreshPayments} />
                            ]}
                            excludeDate={d =>
                                !isMondayLocal(d) || // Only allow selecting Mondays
                                !isPastOrNextMonday(d) // Only allow selecting up to the next week
                            }
                            clearable={false}
                        />
                    }</div>}
                theadStyles={{
                    position: 'sticky',
                    top: '0px',
                    zIndex: 99,
                    height: DayHeaderHeight,
                    maxHeight: DayHeaderHeight,
                }}
                tableHeadingRow={<TableHeadingRow agent_type={agent_type} />}
                topControlsArea={AdminListQuotesPage.TopControlsArea({
                    bulkActionsSelect,
                    applyButton,
                    statusSelect: [],
                    searchInput: null, // <TextInput placeholder="Search pages" />,
                })}
                tableRows={<PaymentRows
                    {...{
                        paymentsInFooter: sortedPayments,
                        user,
                        paymentsInTable: sortedPayments.filter(p => (!effectiveAgentFilter.length) || effectiveAgentFilter.includes(p.TeamMember)),
                        rates,
                        target,
                        selectedWeek,
                    }}
                />}
                bottomArea={AdminListQuotesPage.BottomArea({
                    leftContent,
                    rightContent, //:  paginate && <Pagination color="brandBlack" value={page} total={Math.ceil(listResults.length / QUOTES_PER_PAGE)} onChange={setPage} />,
                })}
            />
        </ErrorBoundary>
    </>} />)
}

export function isMondayLocal(d: Date) {
    return d.getDay()==1
}
const omitKey = (key:string) => (o:Record<string,any>={}) => {
    try {
        const { [key]: _, ...rest} = o
        return rest
    } catch (e) {
        return o
    }
}
const AgentFilterAtom = atom<string[]>({
    key: 'agentFilter',
    default: [],
})

const AgentFilter = () => {
    // const myManagedAgents = useRecoilValue(managedAgentsAtom)
    // const allShownAgents = useRecoilValue(allAgentsWithPaymentsAtom)
    const allAgents = useRecoilValue(allAgentsAndAdminsAtom)
    const allTeams = useRecoilValue(allTeamsAtom)
    const teams = Array.from(new Set(Object.values(allTeams).flat()))
    const options = Object.keys(allAgents??{}) // allShownAgents // myManagedAgents
    const [agentFilter, setAgentFilter] = useRecoilState(AgentFilterAtom)
    return <span style={{display:'flex', maxWidth: '10vw'}}>
        <MultiSelect
            style={{width:'auto'}}
            value={agentFilter.map(o => o.replace('@ratpacktravel.com','@'))}
            onChange={v => setAgentFilter(v.map(o => o.replace(/@$/,'@ratpacktravel.com')))}
            placeholder='(any)'
            data={[
                ...teams.map(t => `#${t}`),
                ...options.map(o => o.replace('@ratpacktravel.com','@')),
            ]}
            searchable
        />
        <ActionIcon
            style={{ padding: '8px 0 0 5px', color: 'gray', display: 'inline' }}
            onClick={() => {
                setAgentFilter([])
            }}
            disabled={(!agentFilter.length) || options.every(a => agentFilter.includes(a))}
        >
            <AiOutlineUndo size={16} id="resetIcon" />
        </ActionIcon>
    </span>
}
const GraphModal = ({
    paymentStats,
    admin,
}) => {
        const [viewingGraph, setViewingGraph] = useRecoilState(viewingGraphAtom)
        const allAgents = useRecoilValue(allAgentsAndAdminsAtom)
        return (<Modal
                key="graph"
                opened={Boolean(viewingGraph)}
                onClose={() => setViewingGraph(null)}
                closeOnClickOutside
                fullScreen
                title={<SegmentedControl data={admin?['Units','Comm','UnitsAdmin','CommAdmin','Averages','Target']:['Units','Comm','Averages','Target'] as graphOption[]} value={viewingGraph} onChange={(e:graphOption)=>setViewingGraph(e)}></SegmentedControl>}
            >
            <BarGraph
                horizontal={['Units','Comm','UnitsAdmin','CommAdmin'].includes(viewingGraph)}
                defaultColor={hotPink} // Hot pink
                // data={sortByValue(accumulateByKey(weekFooterDataBy(visiblePayments, rates, (p: Payment) => p?.TeamMember?.split('@')[0]), viewingGraph))}
                data={omitKey('no team')(paymentStats?.[viewingGraph])}
                // fmt={["Units"].includes(viewingGraph) ? v=>v.toString() : (v: number) => `$${(v / 100).toFixed(2)}`}
                // fmt={["Units"].includes(viewingGraph) ? v=>v.toString() : dollar}
                formatValue={["Units","UnitsAdmin"].includes(viewingGraph) ? v=>v.toString() : dollar}
                // formatKey={v=>v?.toString()?.split('@')[0]}
                formatKey={v=>allAgents[v?.toString()] ?? v?.toString().split('@')[0]}
                style={{
                    maxHeight:'90vh',
                    maxWidth:'98vw',
                }}
                />
        </Modal>)
        }

const TableHeadingRow = ({
    agent_type,
}) => {

    const setViewingGraph = useSetRecoilState(viewingGraphAtom)

    const { before, groups, after } = HEADERS[agent_type]
    const thStyle = { border: 0, borderCollapse: 'collapse' } as React.CSSProperties
    return <>
        <tr>
            {before.map((v: string | null) => v ? (<th style={thStyle}> <Anchor styleType="table-header">{v}</Anchor> </th>) : (<th style={thStyle} />))}
            {Object.entries(groups).map(([k, v]: [string, Array<string | null>], i: number) =>
            (k=='Team' ? <th key={i} colSpan={v?.length ?? 1} style={{ border: 0, backgroundColor: [NORMAL, SHADED][i % 2], textAlign: 'center' }}>
                <AgentFilter/>
            </th> : v ? (
                <th key={i} colSpan={v?.length ?? 1} style={{ border: 0, backgroundColor: [NORMAL, SHADED][i % 2], textAlign: 'center' }}>
                    <Anchor styleType="table-header" onClick={e=>{
                        if(k=='Commission') setViewingGraph('Target')
                    }}>{k}</Anchor>
                </th>
            ) : (<th style={{ border: 0 }} />))
            )}
            {after.map((v: string | null) => v ? (<th style={thStyle}> <Anchor styleType="table-header">{v}</Anchor> </th>) : (<th style={thStyle} />))}
        </tr>
        <tr>
            {before.map((v: string | null) => (<th style={thStyle} />))}
            {Object.entries(groups).flatMap(([k, v]: [string, Array<string | null>], i: number) =>
                v.map((v, j) => (v ? (<th key={i + '.' + j} style={{ ...thStyle, backgroundColor: getColShade(HEADERS[agent_type], [i, j]) }}><Anchor styleType="table-header">{v}</Anchor></th>) : (<th style={thStyle} />)))
            )}
            {after.map((v: string | null) => (<th style={thStyle} />))}
        </tr>
    </>
}

const baseTDStyle = {
    fontSize: '16px',
    lineHeight: '1.55',
}
export const SimplifiedTableRow = ({ topLine, agent_type, ...rest }) => {
    return <>
        <tr {...rest}>
            {topLine.map((v: any, i: number) => {
                return <td style={{ ...baseTDStyle, backgroundColor: getColShade(HEADERS[agent_type], i) }}>{v}</td>
            })}
        </tr>
        {false && <tr style={{ backgroundColor: 'grey' }}>
            <td style={{ padding: 0, borderBottom: 0 }}></td>
            <td style={{ padding: 0, borderBottom: 0 }}></td>
        </tr>}
    </>
}
const toCountryFlag = (country: string, showUnknown = false) => {
    const LUT = {
        AU: 'AU',
        NZ: 'NZ',
        Australia: 'AU',
        NewZealand: 'NZ',
        'New Zealand': 'NZ',
    }
    const LUTText = {
        Australia: 'Australia 🇦🇺',
        NewZealand: 'New Zealand 🇳🇿',
        'New Zealand': 'New Zealand 🇳🇿',
    }
    const LUTColor = {
        Australia: 'blue',
        NewZealand: 'green',
        'New Zealand': 'green',
    }
    const unknown = 'Unknown'
    const label = LUTText[country?.split('/')[0]] ?? country ?? unknown
    const color = LUTColor[country?.split('/')[0]] ?? LUTColor[country] ?? 'red'
    const body = LUT[country?.split('/')[0]] ?? country?.split('/').at(-1) ?? country ?? unknown
    if (label == unknown && !showUnknown) return []
    return <Tooltip label={country} style={{ display: 'inline' }}><div style={{ width: 'max-content', display: 'inline', padding: '0 5px 0 0' }}>
        <Badge
            style={{ cursor: 'default' /*, backgroundColor:color NOTE: overrides color, uses css blue #0000FF not theme blue #228BE6 */ }}
            color={color}
            variant="filled"
        >{body}</Badge>
    </div></Tooltip>
    return LUT[country] ?? country
}
const statusRemap = (status: Payment["SaleType"]) => ({
    full_payment: 'PayOffFull',
    deposit: 'NewSaleDeposit',
}[status] ?? status)
const statusColor = (status: Payment["SaleType"]) => {
    // status = (status ?? '').toLowerCase()
    // console.log({status,color:LUT[statusRemap(status)]})
    return SaleTypeColor[statusRemap(status)] ?? 'gray'
}
const toSaleTypeFlag = (saleType: string) => {
    const remap = statusRemap(saleType as any)
    const backgroundColor = statusColor(remap as any) ?? 'black'
    return <Tooltip label={SaleTypeLong[remap] ?? remap} style={{ display: 'inline' }}><div style={{ width: 'max-content' }}>
        <Badge style={{ cursor: 'default', backgroundColor }} color={backgroundColor} variant="filled">{SaleTypeShort[remap] ?? remap}</Badge>
    </div></Tooltip>
}
const SHADED = 'rgb(232, 232, 232)'
const NORMAL = null // '#ffffff'
const getColShade = (layout = HEADERS.admin, N: number | [number, number]) => { // N is either the column number (including the before cols) or the group number and offset within that group (excluding before cols)
    const groups:Array<[keyof typeof layout.groups, typeof layout.groups[keyof typeof layout.groups]]> = Object.entries(layout.groups) as Array<[keyof typeof layout.groups, typeof layout.groups[keyof typeof layout.groups]]>
    const n = typeof N == 'number' ? N : groups.reduce((t, [k, v], i) => t + (N[0] > i ? v.length : 0), N[1] + layout.before.length)
    const cols = groups.flatMap(([k, v], i) => v)
    if (cols[n - layout.before.length] == 'Comm AUD') return COMMISSION_SHADE

    const LUT = [
        ...layout.before.map(v => NORMAL),
        ...groups.flatMap(([k, v], i) => v.map(w => [NORMAL, SHADED][i % 2])),
        // ...groups.flatMap(([k, v], i) => ([''] as Array<keyof typeof layout.groups>).includes(k) ? NORMAL : v.map(w => [NORMAL, SHADED][i % 2])),
        ...layout.after.map(v => NORMAL),
    ]
    return LUT[n] ?? NORMAL
}

const spinOnce = (id:string) => {
    const element = document.getElementById(id);
    element.style.transition = 'transform 1s linear';
    element.style.transform = 'rotate(360deg)';
    
    setTimeout(() => {
        element.style.transition = 'none';
        element.style.transform = 'rotate(0deg)';
    }, 1000);   
}

const CurrencyValue = (rates: PaymentResponse['rates'] | null, cents: number, fromCurrency: FXCurrency | 'AUD', hideImpliedCurrencySuffix = false, extraStyle: any = {}, showBaseCurrency = false, extraText = '') => {
    const rate = rates?.rates?.[fromCurrency]
    const content = [
        (cents / 100).toFixed(2),
        hideImpliedCurrencySuffix ? null : fromCurrency,
    ].filter(Boolean).join(' ')
    const text = <p><Text size="sm" style={{
        // textDecoration:'underline dashed',
        fontWeight: 'bold',
        color: 'black',
        wordBreak: 'break-word',
        ...extraStyle,
    }}>{content}{showBaseCurrency?` ${fromCurrency}`:''}</Text></p>

    const convert = () => {
        if (!rates) return `Loading conversion rates`
        if (!rate) return `No conversion rate for ${fromCurrency} to AUD`
        return `${((cents / rate) / 100).toFixed(2)} AUD`
    }
    const label = [
        fromCurrency == 'AUD' ? '' : convert(),
        extraText,
    ].filter(Boolean).join('\n')
    if(!label) return text

    return <Tooltip
        label={label}
        style={{ display: 'inline' }}
    >{text}</Tooltip>
    // TODO: div should not appear within td, but is required here for hover effect
}

const lightRed = '#ffbbbb'
const yellow = '#FFD700'
type PaymentTable = {
    "PaxName": any,
    "Model": any,
    "Duration": any,
    "Sale Type": any,
    "Stripe": any,
    "Card Fee (2.9%)": any,
    "Stripe Fee": any,
    "Total (AUD)": any,
    "Camper": any,
    "Team Member": any,
    "Ad Referral": any,
    "Confirmation": any,
    "Comm AUD": any,
    "Notes": any,
    // Gross: any,
}
type WeekFooter = {
    "Total": any,
    "Stripe Fees": any,
    "Card Fees": any,
    "Gross": any,
    "Comm AUD": any,
    "Comm NZD": any,
    "Comm": any,
    "Target": any,
    "Day Target": any,
    "Remaining": any,
}
function infoToRowContent(content: Partial<PaymentTable>, groups: Record<string, string[]>) {
    return Object.values(groups).flat().map(k => content[k])
}
const openTab = (url: string, e?: InputEvent): false => {
    window.open(url, '_blank');
    if (e) e.preventDefault()
    return false
}

const ZDIDPill = (ZDTicketID: string) => <Badge
    color="gray"
    variant="filled"
    style={{ cursor: 'pointer' }}
    onClick={e => openTab(`${ZD_URL}/${ZDTicketID}`)}
>ZD:{ZDTicketID}</Badge>

export const PaymentToRowItem = ({
    payment,
    rates,
    setEditingPayment,
    agent_type,
}: {
    payment: Payment,
    rates: PaymentResponse['rates'],
    setEditingPayment: Function,
    agent_type: string,
}) => {
    const { groups } = HEADERS[agent_type]
    const Currency = {
        'AU': 'AUD',
        'NZ': 'NZD',
    }[NormalizeToCountryCode(payment.Country)] as 'AUD' | 'NZD' // NOTE: this is not the currency of the payment, but the currency of the trip location

    const warningLosingMoney = false // (payment.CommAUD>payment.TotalAUD) // Currency=='AUD' ? payment.CommAUD>payment.StripeAUD : ... ;
    return <SimplifiedTableRow
        agent_type={agent_type}
        key={payment.id}
        style={(payment.NOTES?.startsWith('WARNING:') || warningLosingMoney) ? {backgroundColor:yellow} : (payment.NOTES?.startsWith('PENDING:') ? {backgroundColor:lightRed} : {})}
        onClick={(e) => {
            console.log({ edit: payment, t: e.target.tagName, ct: e.currentTarget.tagName })
            if (window.getSelection().toString()) return console.log(`Ignore row click on element ${e.target.tagName} because of selection`)
            if (!e.target.matches('tr, td')) return console.log(`Ignore row click on element ${e.target.tagName} because of tag name`)
            setEditingPayment(payment)
        }}
        {...({
            topLine: [ // ADMIN: TODO join with the header setup
                [], // <Checkbox />,
                ...infoToRowContent({
                    // "PaxName": [NameZD, <br />, toCountryFlag(payment.PaxLocation),StripePill],
                    "PaxName": [payment.PaxName, <br />, toCountryFlag(payment.PaxLocation), <Text size="xs">{timeInSydney24(payment.paid_at)}</Text>],
                    // "ZDID": ZDID,
                    "Model": [<b>{NormalizeToCompanyName(payment?.Company, payment?.Country)}</b>, <br />, <p style={{ paddingRight: '20px', margin: 0, display: 'inline' }}>{payment.Model ?? '(no model)'}</p>, toCountryFlag(payment.Country)],
                    "Duration": payment.Duration,
                    "Sale Type": toSaleTypeFlag(payment.SaleType),
                    "Stripe": Currency == 'AUD' ? CurrencyValue(rates, payment.StripeAUD, 'AUD') : CurrencyValue(rates, payment.StripeNZD, 'NZD'),
                    "Card Fee (2.9%)": CurrencyValue(rates, payment.CardFee, Currency as FXCurrency,false,{},false,'Actual: ...'),
                    // "Stripe Fee": CurrencyValue(rates, payment.StripeFee, Currency as FXCurrency),
                    // "Total (AUD)": CurrencyValue(rates, payment.TotalAUD, 'AUD', true),
                    "Camper": <b>{Currency == 'AUD' ? CurrencyValue(rates, payment.CamperAUD, 'AUD') : CurrencyValue(rates, payment.CamperNZD, 'NZD')}</b>,
                    "Team Member": <Anchor href="#">{payment.TeamMember?.split('@')[0]}</Anchor>,
                    "Ad Referral": <Tooltip label={payment.AdReferral} style={{ display: 'inline' }}><div>
                        <Text style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            wordBreak: 'break-all',
                            width: '30px',
                            display: 'inline-block',
                            textDecoration: 'underline',
                            whiteSpace: 'nowrap',
                        }}>{payment.AdReferral}</Text>
                    </div></Tooltip>,
                    "Confirmation": <Text size='xs' style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-all',
                        maxWidth: '80px',
                        minWidth: '60px',
                        // maxHeight: '30px',
                        // display: 'inline-block',
                        // whiteSpace: 'nowrap', 
                        maxHeight: '7rem',
                    }}>{payment.InitialsConfirmation}</Text>,
                    "Comm AUD": CurrencyValue(rates, payment.CommAUD, 'AUD', true, { textAlign: 'center' }, true),
                    "Notes": <Tooltip label={[payment.NOTES]} multiline width={700} withArrow style={{textOverflow:'ellipsis'}}><div>
                        <Text size='xs' style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            wordBreak: 'break-all',
                            maxWidth: '30px',
                            // maxHeight: '30px',
                            // display: 'inline-block',
                            // whiteSpace: 'nowrap', 
                            maxHeight: '3.5rem',
                        }}>{payment.NOTES}</Text>
                    </div></Tooltip>,
                }, groups),
            ],
        })}
    />
}
export class ErrorBoundary extends React.Component<{ fallback: any }, { hasError: Boolean, artifact: string, error?: Error }> {
    constructor(props) {
        super(props);
        this.state = { hasError: false, artifact: 'Loading..', error: null };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, artifact: 'Loading' };
    }
    componentDidCatch(error, info) {
        console.error({ error, info })
        this.setState(s=>Object.assign(s,{artifact:'Loading...'}))
        POST(`/api/artifact/submit`, {
            error,
            info,
            stack: error.stack,
            comp: info.componentStack,
        }).then(res => {
            this.setState(s=>Object.assign(s,{artifact:res.key}))
            console.error({ reportedError: res })
        }).catch(e => {
            this.setState(s=>Object.assign(s,{error:e}))
            console.error({ failedToReportError: e })
        })
    }

    render(): any { // React.ReactNode {
        if (this.state.hasError) {
            return <div style={{padding:'50px'}}>
                <Text>{this.props.fallback}</Text>
                <br />
                {this.state.artifact?.includes?.('Loading') ?
                    <Text>Submitting bug report...</Text> :
                    (this.state.error)?.message ?
                        <Text>Failed to submit error report. This usually means that the server is unable to process the request right now. <Text size='xs'>{this.state.error?.message}</Text></Text> :
                        <Text>This bug report has been submitted (ID:{this.state.artifact}).</Text>
                }
                <Button onClick={e => this.setState({ hasError: false, artifact: 'Loading', error: null })}>Try Again</Button>
            </div>
        }

        return this.props.children;
    }
}